
import ResultPictureComponent from "@/components/RegisterTest/ResultPicture/ResultPictureComponent";
export default ResultPictureComponent;
